export enum ELocale {
  FR = "fr",
  EN = "en",
}
